import { Pipe, PipeTransform, NgModule } from '@angular/core';
import { formatCurrency, getCurrencySymbol, CommonModule } from '@angular/common';
import { SystemDefaultModel, ChineseDefaultModel } from 'src/app/models/non-master-model/SystemDefaultModel';
import { UnitMediPurchaseService } from '../Unit/UnitMediPurchase.service';
import { UnitMediStockService } from '../Unit/UnitMediStock.service';
import { UnitItemService } from '../Unit/UnitItem.service';
import { UnitMediStockModel } from 'src/app/models/UnitMediStockModel';
import { UnitMediPurchaseModel } from 'src/app/models/UnitMediPurchaseModel';
import { UnitItemModel } from 'src/app/models/UnitItemModel';


@Pipe({
  name: 'appCurrency',
})
export class AppCurrencyPipe implements PipeTransform {
  transform(
    value: number,
    currencyCode: string = 'HKD',
    display:
      | 'code'
      | 'symbol'
      | 'symbol-narrow'
      | string
      | boolean = 'symbol',
    // display format
    digitsInfo: string = '0.1-1',
    // digitsInfo: string = '0.0-0',
    locale: string = "zh-Hans-HK",
  ): string | null {
    return formatCurrency(
      value,
      locale,
      //wide:show text , narrow : not show text EG (HK)
      getCurrencySymbol(currencyCode, 'narrow'),
      currencyCode,
      digitsInfo,
    );
  }


}

@NgModule({
  declarations: [ AppCurrencyPipe],
  imports: [CommonModule],
  exports:[AppCurrencyPipe],//export list here 
  providers: []
})
export class AppCurrencyPipeModule { }

